import { URI } from '@/config/config';

export default async ({ rootState }, { clientId, userToken }) => {
  const token = rootState['DATA-ACCESS'].tokenAuth;
  const opts = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken,
      Authorization: `Bearer ${token}`,
    },
  };

  const result = await fetch(
    `${URI}user/remove-available-client/${userToken}/${clientId}`,
    opts,
  );
  const jsonResult = await result.json();

  if (result.status >= 400) {
    return Promise.reject(jsonResult.message);
  }

  return jsonResult;
};
